import { Component } from '@angular/core';

@Component({
  selector: 'app-fitbit-redirect',
  templateUrl: './fitbit-redirect.component.html'
})
export class FitbitRedirectComponent {}
